import React, { useEffect, useState } from "react";
import UserCard from "../components/layout/UserCard";
import { getUser } from "../api/getUser";
import UserAchivments from "../components/layout/UserAchivments";
import UserTasks from "../components/layout/UserTasks";
import DailyTasks from "../components/layout/DailyTasks";
import { httpReauest } from "../utils/httpRequest";
import Loading from "../components/common/Loading";

const DailyRewardPage = () => {
  const [data, setdata] = useState();
  const [tasks, settasks] = useState();
  const [loading, setloading] = useState(true);

  useEffect(() => {
    getData();
    getTasks()
  }, []);

  async function getTasks(params) {
    setloading(true);
    const res2 = await httpReauest("GET", "/tasks", {}, {});
    settasks(res2?.data?.data);
    setloading(false);
  }
  async function getData() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      window.location.href = window.origin;
    }
    const res = await httpReauest(
      "GET",
      "/user/wheel/",
      {},
      { "x-access-token": user?.token }
    );
    setdata(res.data.data);
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="w-full py-6 text-white">
      {tasks?.wheel ? (
        <DailyTasks data={data} getData={getData} />
      ) : (
        <div className="rounded-[26px] bg-[#4A5A69] p-6 flex justify-center flex-col items-center relative shadow shadow-white/40 border border-white/10 min-h-52">
          <div className="flex flex-col w-full gap-3 justify-center items-center text-2xl">
            there's no item in Daily Reward
          </div>
        </div>
      )}
    </div>
  );
};

export default DailyRewardPage;
